var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-field-selection',{attrs:{"selection-name":"company.company","field-name":"companyId","label":"company","error":_vm.error,"clearable":_vm.clearable,"all-option":_vm.allOption,"disabled":_vm.n_disabled,"no-modified-icon":_vm.noModifiedIcon},on:{"on-change":_vm.onChange,"on-select":v => {
      this.$emit('on-select', v);
    }},model:{value:(_vm.n_value),callback:function ($$v) {_vm.n_value=$$v},expression:"n_value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }